import MessageFormatOptionState from './schema/MessageFormatOptionState';
import { createStore } from 'satcheljs';

export default createStore<MessageFormatOptionState>('messageFormatOption', {
    showBcc: null,
    showFrom: null,
    composeFormat: null,
    fontFamily: null,
    fontSize: null,
    isFontBold: null,
    isFontItalic: null,
    isFontUnderline: null,
    fontColor: null,
    isColorMenuShown: false,
})();
